<template>
	<div class="view-index-v" @click="closeCapsuleDialog">
		<div class="svg-box"></div>
		<div class="inf-wrapper">
			<div class="auto-height">
				<div class="inline-start title-line calc-line">
					<div class="line"></div>
					<div class="caption">蓝鲸众联简介</div>
				</div>
			</div>
			<div class="auto-height">
				<div class="content calc-line" v-html="companyProfile"></div>
			</div>
		</div>
		<div class="inf-wrapper">
			<div class="auto-height">
				<div class="inline-start title-line calc-line">
					<div class="line"></div>
					<div class="caption">品牌文化</div>
				</div>
			</div>
			<div class="auto-height">
				<div class="content calc-line" v-html="corporateCulture"></div>
			</div>
		</div>
		<div class="inf-wrapper">
			<div class="auto-height">
				<div class="inline-start title-line calc-line">
					<div class="line"></div>
					<div class="caption">企业荣誉</div>
				</div>
			</div>
			<div class="auto-height">
				<div class="content calc-line" v-html="corporateHonors"></div>
			</div>
		</div>
		<div class="inline-start-b capsule-dialog" :style="capsuleDialogStyle"
			@mousemove="onHoldCapsuleDialog" @mouseleave="onMouseoutArea" @click.stop="onClickCapsule">
			<img class="park-area-point" src="~@/assets/png/park-area-point.png" />
			<div class="capsule" v-show="!curCapsuleDialogStatus.showDialog">
				<span>{{curArea.promptText}}</span>
				<i class="el-icon-arrow-right"></i>
			</div>
		</div>
		<div class="pop-dialog" :style="popDialogStyle"
			@mousemove="onHoldCapsuleDialog" @mouseleave="onMouseoutArea">
			<img class="bg" :style="popDialogBgStyle" src="~@/assets/png/pop-bg.png" />
			<div class="content-wrapper" @click.stop="onClickPopDialog">
				<div class="auto-height">
					<div class="content calc-line" v-html="curArea.popContent"></div>
				</div>
			</div>
		</div>
		<channel-list />
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import IndexMixin from './mixins/index.js';
	import ChannelList from '@/components/controlsV/ChannelList.vue';
	export default {
		name: 'IndexV',
		mixins: [IndexMixin],
		components: {
			ChannelList
		},
		data() {
			return {
				
			}
		},
		computed: {
			capsuleDialogStyle() {
				if(this.curCapsuleDialogStatus.show) {
					return {
						left: (this.curCapsuleDialogStatus.x - 4 * this.scaleRate) + 'px',
						top: (this.curCapsuleDialogStatus.y - 4 * this.scaleRate) + 'px'
					}
				}else {
					return {
						display: 'none'
					}
				}
			},
			popDialogStyle() {
				if(this.curCapsuleDialogStatus.showDialog) {
					let left = 0;
					if(this.curCapsuleDialogStatus.rootDomW / 2 < this.curCapsuleDialogStatus.x) {
						left = (this.curCapsuleDialogStatus.x - (4+264-49-10) * this.scaleRate);
					}else {
						left = (this.curCapsuleDialogStatus.x - (4+49 - 20) * this.scaleRate);
					}
					return {
						left: left + 'px',
						top: (this.curCapsuleDialogStatus.y + (-4+21) * this.scaleRate) + 'px'
					}
				}else {
					return {
						display: 'none'
					}
				}
			}
		},
		methods: {
			
		}
	}
</script>
<style scoped lang="less">
	.view-index-v {
		width: 100%;
		position: relative;
		.svg-box {
			//border: 1px solid #000000;
			width: 100%;
			height: calc(500px * var(--scale-rate));
			margin-bottom: calc(70px * var(--scale-rate));
			overflow: hidden;
		}
		.inf-wrapper {
			width: 100%;
			padding: 0 calc(52px * var(--scale-rate)) calc(70px * var(--scale-rate));
			.title-line {
				width: calc(100% / var(--scale-rate));
				transform: scale(var(--scale-rate));
				transform-origin: left top;
				.line {
					background-color: rgb(17, 74, 117);
					width: 4px;
					height: 38px;
				}
				.caption {
					margin-left: 15px;
					font-size: 40px;
					color: rgb(29, 41, 116);
				}
			}
			.content {
				width: calc(100% / var(--scale-rate));
				font-size: 30px;
				letter-spacing: 12px;
				font-weight: 300;
				color: rgb(35, 35, 35); 
				transform: scale(var(--scale-rate));
				transform-origin: left top; 
				padding-top: 40px;
				padding-left: 27px;
			}
		}
		
		.capsule-dialog {
			height: calc(42px * var(--scale-rate));
			.park-area-point {
				width: calc(28px * var(--scale-rate));
				height: calc(28px * var(--scale-rate));
				margin-right: calc(7px * var(--scale-rate));
			}
		}
		
		.pop-dialog {
			width: calc(264px * var(--scale-rate)); 
			height: calc(387px * var(--scale-rate));
			.content-wrapper {
				top: calc(45px * var(--scale-rate));
				left: calc(14px * var(--scale-rate));
				right: calc(14px * var(--scale-rate));
				bottom: calc(14px * var(--scale-rate));
			}
		}
	}
</style>